import React from 'react';
import classnames from 'classnames';
import { getProfessionMessage } from '../../appMessageDefinitions';
import { ApplyMountEffect, cardRevealEffect } from '../../helpers/reveals';
import { H4 } from '../../primitives/appTitle';
import {
  ShIntlMessageDefinition,
  ShText,
  useShIntlLocale,
} from '@shoootin/translations';
import {
  AppInternalLink,
  AppInternalPath,
  AppInternalPaths,
} from '../../primitives/appLink';
import { AppGatsbyImage, AppGatsbyImageFluid } from '../../primitives/appImage';
import { FrontCommonMessages } from '../../appCommonTranslations';
import { ProfessionShootingType } from '../../appConstants';
import useProfessionFirstImages from '../../queries/useProfessionFirstImages';

const MetierCover = ({
  image,
  to,
  label,
}: {
  image: AppGatsbyImageFluid;
  to: AppInternalPath;
  label: ShIntlMessageDefinition;
}) => (
  <AppInternalLink to={to}>
    <div className="cover-wrapper">
      <div className={classnames('cover', 'preview')}>
        <div className="cover__link">
          <div className="cover__legend">
            <H4>
              <ShText message={label} />
            </H4>
            <p className="link invert">
              <ShText message={FrontCommonMessages.seeProfession} />
            </p>
          </div>
        </div>
        <AppGatsbyImage
          className="cover__image"
          fluid={image}
          style={{ position: 'absolute' }}
        />
      </div>
    </div>
  </AppInternalLink>
);

const MetierCoverTiles = ({
  professions,
}: {
  professions: ProfessionShootingType[];
}) => {
  const locale = useShIntlLocale();
  const firstImages = useProfessionFirstImages(locale);
  return (
    <div className="cover-tiles">
      {professions.map((profession, i) => (
        <ApplyMountEffect key={i} index={i} effect={cardRevealEffect}>
          {(ref) => (
            <div ref={ref} className="cover-tile">
              <MetierCover
                image={firstImages[profession]}
                to={AppInternalPaths.profession(profession)}
                label={getProfessionMessage(profession, 'short')}
              />
            </div>
          )}
        </ApplyMountEffect>
      ))}
    </div>
  );
};

export default MetierCoverTiles;
